import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { SelectOutlined } from '@ant-design/icons';
import { fetchCodesOfUser } from 'redux/actions/user.action';
import { Button, PageLoader } from '@kambria/kambria-lego';
import LoadingButton from 'views/components/LoadingButton';
import utils from 'helpers/utils';

function ETHAddress({ address, txId }) {
  const onViewEthScan = () => {
    if (!txId) return;
    return utils.viewEtherScan(txId);
  };
  const style = {
    eth: { display: 'flex', alignItems: 'center' },
    address: { margin: 0 },
    icon: { fontSize: 12 },
  };
  return (
    <div style={style.eth}>
      <p style={style.address}>{utils.shortenString(address)}</p>
      {txId && <SelectOutlined style={style.icon} onClick={onViewEthScan} />}
    </div>
  );
}

function DateView({ date }) {
  const dislayedDate = moment(date).format('MMM DD YYYY [\r\n] HH:mm:ss');
  return <p style={{ whiteSpace: 'pre', margin: 0, fontSize: 14 }}>{dislayedDate}</p>;
}

function StatusCode({ status }) {
  const { color, text } = (() => {
    switch (status) {
      case 'PROCESSED':
        return { text: 'COMPLETED', color: '#2aa58e' };
      case 'REJECTED':
        return { text: 'REJECTED', color: '#e2515e' };
      case 'PENDING':
        return { text: 'IN REVIEW', color: '#ffa702' };
      default:
        return {};
    }
  })();
  const statusStyle = {
    fontSize: 14,
    fontWeight: '700',
    padding: 8,
    borderRadius: 8,
    color,
  };
  return <p style={statusStyle}>{text}</p>;
}

function WithdrawList({ codes }) {
  if (!codes.length) {
    return <p>Your allocation will be available soon</p>;
  }

  return (
    <div className="table-responsive">
      <table className="w-100 table">
        <thead>
          <tr>
            <th className="pr-2" scope="col">
              Date
            </th>
            <th className="pr-2" scope="col">
              Amount
            </th>
            <th className="pr-2" scope="col">
              Type (Fee)
            </th>
            <th className="pr-3" scope="col">
              ETH Address
            </th>
            <th className="pr-2" scope="col" style={{ padding: '9px 8px' }}>
              Status
            </th>
          </tr>
        </thead>
        <tbody>
          {codes.map((code, index) => (
            <tr key={index}>
              <td className="w-25 pr-2" style={{ whiteSpace: 'nowrap' }}>
                <DateView date={code?.updatedAt} />
              </td>
              <td className="w-25 pr-2">{code?.amount}</td>
              <td className="w-25 pr-2">{`${code?.type} (${code?.gasFee || 0})`}</td>
              <td className="w-25 pr-3">
                <ETHAddress address={code?.address} txId={code?.transactionId} />
              </td>
              <td className="w-100 pr-2">
                <StatusCode status={code?.status} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

const LIMIT_PAGE = 10;

function CodesList({ fetchCodesOfUser, codes, account, loadingCodes }) {
  useEffect(() => {
    fetchCodesOfUser({ page: 1, limit: LIMIT_PAGE });
  }, [fetchCodesOfUser]);

  const { data, page, total } = codes;
  const isEmptyCode = !data || !Array.isArray(data) || data.length === 0;

  return (
    <div>
      <span className="label">Your Connect Address wallet</span>
      <p className="mb-4">{account}</p>
      <span className="label">If you change your wallet address, please update and reload the page.</span>
      <br />
      <span className="label">Available to withdraw</span>
      <div className="row mb-4 mt-3">
        {isEmptyCode ? <PageLoader type="position" /> : <WithdrawList codes={data} />}
      </div>
      {LIMIT_PAGE * (page - 1) < total && (
        <div style={{ textAlign: 'center' }}>
          <LoadingButton
            onClick={() => fetchCodesOfUser({ page, limit: LIMIT_PAGE })}
            loading={loadingCodes}
            variant="gray"
            size="sm"
          >
            Load more
          </LoadingButton>
        </div>
      )}
      <Link to="/contact">
        <Button type="gray" size="sm">
          Get Help
        </Button>
      </Link>
    </div>
  );
}

const mapStateToProps = (state) => ({
  account: state.blockchain.account,
  codes: state.user.codes,
  loadingCodes: state.user.loadingCodes,
});

const mapDispatchToProps = {
  fetchCodesOfUser
};

export default connect(mapStateToProps, mapDispatchToProps)(CodesList);